export enum AlertLevel {
  Organisation = 0,
  Site = 1,
  AssetFamily = 2,
  Asset = 3,
}
